import { render, staticRenderFns } from "./BackdropComponent.vue?vue&type=template&id=4fa9b15c&scoped=true&"
import script from "./BackdropComponent.vue?vue&type=script&lang=js&"
export * from "./BackdropComponent.vue?vue&type=script&lang=js&"
import style0 from "./BackdropComponent.vue?vue&type=style&index=0&id=4fa9b15c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa9b15c",
  null
  
)

export default component.exports